import styled from 'styled-components'
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles'

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 0.5rem;
  max-width: 1100px;
  margin: 0 auto;
`

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: transparent;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  color: var(--primary-blue, #0B4598);
  font-family: var(--fontMain, Poppins), sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  svg {
    font-size: 1.25rem;
  }

  &:hover {
    background: rgba(11, 69, 152, 0.06);
    border-color: var(--primary-blue, #0B4598);
  }

  &:active {
    background: rgba(11, 69, 152, 0.1);
  }
`

export const PageTitle = styled.h1`
  flex: 1;
  font-family: var(--fontMain, Poppins), sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.2;
  text-align: center;
  margin: 0;
  padding-right: 85px; /* Offset for back button width to center title visually */
  color: #1F2937;
`

export const Container = styled.div`
  max-width: 1320px;
  margin: 0 auto;
  padding: 24px 12px 48px;

  @media (max-width: 1024px) {
    padding: 20px 10px 40px;
  }
  @media (max-width: 768px) {
    padding: 16px 8px 32px;
  }
`

export const Header = styled.div`
  text-align: center;
  margin: 0 0 24px;
`

export const Subtitle = styled.p`
  font-size: 14px;
  color: #666;
`

export const Section = styled.section`
  margin: 24px auto;
  border: 1px solid #f0f0f0;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  width: min(100%, 1100px);

  @media (max-width: 1024px) {
    width: min(100%, 1000px);
  }
  @media (max-width: 768px) {
    width: 100%;
    border-radius: 14px;
  }
`

export const SectionTitle = styled.h3`
  font-weight: 600;
  padding: 16px 20px 8px;
  border-bottom: 2px solid #f7f7f7;
  margin: 0;
`

export const SectionBody = styled.div`
  padding: 22px 26px 26px;
  display: grid;
  grid-template-columns: 0.9fr 2.1fr;
  gap: 12px 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 14px 14px 18px;
  }
`

export const Label = styled.label`
  align-self: start;
  font-weight: 500;
  color: #333;
  text-align: left;
  justify-self: start;
`

export const ActionBar = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.75rem;

  & > button {
    max-width: 280px;
    padding: 10px 12px !important;
  }

  @media (max-width: 768px) {
    gap: 0.5rem;
    & > button {
      padding: 0 14px !important;
      border-radius: 12px !important;
    }
  }
`

export const DangerButton = styled(StyledButton)`
  && {
    background: var(--error-main);
    color: #fff;
  }
`

export const ReadOnly = styled.div`
  padding: 16.5px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  min-height: 56px;
  display: flex;
  align-items: center;
  background-color: #fafafa;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  line-height: 1.1876em;
`

export const SaveButton = styled(StyledButton)` 
    background-color: #13CA82 !important;
`

export const HelpText = styled.p`
  margin: 3px 14px 0;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  line-height: 1.66;
  letter-spacing: 0.03333em;
`

export const LabelCol = styled.div`
  display: flex;
  flex-direction: column;
  align-self: start;
  justify-self: start;
  align-items: flex-start;
  text-align: left;
`

export const TextButton = styled.button`
  background: none;
  border: none;
  color: #0B4598;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 0;
  text-decoration: none;
  transition: all 0.2s ease;
  
  &:hover {
    color: #073674;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const DeleteLocationButton = styled(StyledButton)`
  && {
    background: #FB7672 !important;
    color: #fff !important;
    max-width: 280px;
    
    &:hover {
      background: #E86662 !important;
    }
  }
`

export const DeleteActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  margin: 48px auto 24px;
  width: 100%;
  max-width: 400px;
`
